var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.b97dd647004112285c6ea06a79a19c1d.svg#b';
                    var viewUrl = 'sprites.b97dd647004112285c6ea06a79a19c1d.svg#view-b';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 27 26',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };